module.exports = __webpack_public_path__ + "img/pocapi.383d8258.png";